import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("tr", {
        "data-slot": "table-row",
        class: _normalizeClass($setup.cn('data-[state=selected]:bg-muted border-b transition-colors', $setup.props.class))
    }, [
        _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */));
}
